import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TModuleCode = 'FO' | 'ABK' | 'POS' | 'BO';

interface IAppSlice {
  salesDate: {
    pos: string;
    posBackOffice: string;
    fo: string;
    abk: string;
  };
}

export const keyMap: Record<TModuleCode, keyof IAppSlice['salesDate']> = {
  FO: 'fo',
  ABK: 'abk',
  POS: 'pos',
  BO: 'posBackOffice',
};

export const pathToModuleCode: Record<string, TModuleCode> = {
  'point-of-sale': 'POS',
  'front-office': 'FO',
  'back-office': 'BO',
  'accounting-and-finance': 'ABK',
};

const initialState: IAppSlice = {
  salesDate: { fo: '', pos: '', posBackOffice: '', abk: '' },
};

export const AppSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSalesDate: (
      state,
      action: PayloadAction<{ code: TModuleCode; salesDate: string }>,
    ) => {
      const { code, salesDate } = action.payload;
      const targetKey = keyMap[code];

      state.salesDate[targetKey] = salesDate;
    },
  },
});

export const { setSalesDate } = AppSlice.actions;

export default AppSlice.reducer;
